<template>
  <v-dialog v-model="show" persistent max-width="1200px">
    <v-form ref="form" @submit.prevent="action">
      <v-row no-gutters>
        <v-col cols="8">
          <v-card>
            <v-card-title primary-title>
              {{ type }}
            </v-card-title>
            <v-card-text>
              <div>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field
                      v-model="pricing_rules.description"
                      label="Descripción de la regla de precio"
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="6" sm="6">
                    <Selectable
                      label="Propiedades (Por defecto: todas)"
                      prepend-icon="mdi-city"
                      multiple
                      :items="listPropertyCode"
                      v-model="propertiesSelected"
                      item-text="name"
                      item-value="ID"
                      item-group="floor"
                      variant="outlined"
                      color="grey darken-1"
                      :close-on-content-click="false"
                    />
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <v-select
                      :items="sltprocessType"
                      v-model="pricing_rules.process_type"
                      :rules="[v => !!v || 'Campo requerido']"
                      item-text="name"
                      item-value="value"
                      label="Tipo de contrato"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="6" sm="6">
                    <v-select
                      :items="sltmethodPayment"
                      v-model="pricing_rules.method_payment"
                      item-text="name"
                      item-value="value"
                      label="Elige tu forma de pago"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field
                      label="Descripción de la forma de pago"
                      v-model="pricing_rules.description_method_payment"
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <v-col cols="12" md="6" sm="6">
                    <InputAmount
                      :label="mpDepositLabel"
                      v-model="pricing_rules.guarantee_deposit.amount"
                      :type.sync="pricing_rules.guarantee_deposit.type"
                      :disabled="pricing_rules.propertys_code.length > 1"
                    />
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field
                      label="Descripción del apartado"
                      v-model="pricing_rules.description_guarantee_deposit"
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="6" sm="6">
                    <InputAmount
                      v-model="pricing_rules.percentage_down_payment.amount"
                      :type.sync="pricing_rules.percentage_down_payment.type"
                      label="Enganche"
                    />
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field
                      label="Descripción del enganche"
                      v-model="
                        pricing_rules.description_percentage_down_payment
                      "
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <div class="px-3 pt-3 mb-n3">
                    <v-switch
                      v-model="pricing_rules.financing_auto"
                      label="Financiamiento automatico"
                      dense
                    ></v-switch>
                  </div>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="4" sm="6">
                    <InputAmount
                      v-model="pricing_rules.financing.amount"
                      :type.sync="pricing_rules.financing.type"
                      :disabled="pricing_rules.financing_auto"
                      label="Financiamiento"
                      hint="Sobre el valor de la propiedad"
                    />
                  </v-col>
                  <v-col cols="12" md="4" sm="6">
                    <v-text-field
                      label="Meses acordados"
                      v-model="pricing_rules.months_agreed"
                      prefix="#"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="6">
                    <v-text-field
                      label="Intereses"
                      v-model="pricing_rules.financing_interest"
                      prefix="%"
                      type="number"
                      :disabled="
                        pricing_rules.method_payment !== 'financing-interest' &&
                          !pricing_rules.financing_auto
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="6" sm="6">
                    <InputAmount
                      label="Finiquito contra entrega"
                      v-model="pricing_rules.termination_payment.amount"
                      :type.sync="pricing_rules.termination_payment.type"
                      :disabled="pricing_rules.propertys_code.length > 1"
                    />
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field
                      label="Descripción del finiquito de entrega"
                      v-model="pricing_rules.description_termination_payment"
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field
                      label="Gasto administrativo"
                      v-model="pricing_rules.admin_cost"
                      prefix="$"
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="6" sm="6">
                    <v-switch
                      v-model="pricing_rules.apply_discount"
                      :input-value="pricing_rules.apply_discount"
                      label="Aplicar descuento(s)"
                      @change="value => changeActiveDiscount(value)"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="6" sm="6">
                    <v-text-field
                      label="Cantidad de descuentos permitidos"
                      v-model="pricing_rules.number_apply_discount"
                      prefix="#"
                      type="number"
                      :disabled="pricing_rules.apply_discount !== true"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" md="12" sm="12">
                    <v-select
                      :items="listDiscount"
                      v-model="pricing_rules.discounts"
                      clearable
                      chips
                      color="#042956"
                      prepend-icon="mdi-sale"
                      item-text="name"
                      label="Agregar descuento(s)"
                      :disabled="pricing_rules.apply_discount !== true"
                      multiple
                      :counter="pricing_rules.number_apply_discount"
                      v-on:input="limiter"
                      deletable-chips
                    >
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle">
                          <v-list-item-action>
                            <v-icon
                              :color="
                                pricing_rules.discounts.length > 0
                                  ? 'indigo darken-4'
                                  : ''
                              "
                              >{{ icon }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Todos</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.name }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{
                            pricing_rules.discounts.length - 1
                          }}
                          otros)</span
                        >
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn color="error" @click="close" dark class="mb-2">
                Cancelar
              </v-btn>
              <v-btn color="success" type="submit" dark class="mb-2">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="4">
          <ExamplePricingRules
            :pricing-rules="pricing_rules"
            :list-discount="listDiscount"
            :realEstateDiscount="realEstateDiscount"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>

<script>
const initPricing_rules = {
  process_type: "",
  description: "",
  method_payment: "",
  financing: { amount: 0, type: "percentage" },
  financing_interest: "",
  percentage_down_payment: { amount: 0, type: "percentage" },
  description_percentage_down_payment: "",
  guarantee_deposit: { amount: 0, type: "currency" },
  description_guarantee_deposit: "",
  months_agreed: "",
  montly_payment: "",
  description_method_payment: "",
  termination_payment: { amount: 0, type: "percentage" },
  description_termination_payment: "",
  propertys_code: [],
  apply_discount: false,
  number_apply_discount: "0",
  discounts: [],
  admin_cost: 0,
  financing_auto: false
};

export default {
  name: "ModalPricingRules",
  props: {
    listPropertyCode: { type: Array, default: () => [] },
    listDiscount: { type: Array, default: () => [] },
    realEstateDiscount: { type: Array, default: () => [] },
    value: { type: Object },
    show: { type: Boolean },
    type: { type: String } // create or update
  },
  emits: ["action", "close"],
  components: {
    Selectable: () => import("../../common/selectable/Selectable.vue"),
    InputAmount: () => import("./InputAmount.vue"),
    ExamplePricingRules: () => import("./ExamplePricingRules.vue")
  },
  data() {
    return {
      pricing_rules: { ...initPricing_rules },
      sltprocessType: [
        // {
        //   name: "Renta",
        //   value: "rent"
        // },
        {
          name: "Venta",
          value: "sale"
        },
        {
          name: "Preventa",
          value: "pre-sale"
        }
      ],
      sltmethodPayment: [
        {
          name: "Financiamiento",
          value: "financing"
        },
        {
          name: "Financiamiento con intereses (sobre saldos insolutos)",
          value: "financing-interest"
        },
        {
          name: "Contado",
          value: "counted"
        }
      ]
    };
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.pricing_rules = { ...newVal };
        } else {
          this.pricing_rules = { ...initPricing_rules };
        }
      }
    }
  },
  computed: {
    mpDepositLabel() {
      return this.pricing_rules.process_type == "rent"
        ? "Deposito"
        : "Apartado";
    },
    icon() {
      if (this.propertyAllSelected) return "mdi-close-box";
      if (this.propertySelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    propertiesSelected: {
      get() {
        return this.propertiesCodeToId(this.pricing_rules.propertys_code);
      },
      set(newValue) {
        this.pricing_rules.propertys_code = this.propertiesIdToCode(newValue);
      }
    }
  },
  methods: {
    changeActiveDiscount(valor) {
      if (valor) {
        this.pricing_rules.number_apply_discount = 1;
      } else {
        this.pricing_rules.number_apply_discount = 0;
        this.pricing_rules.discounts = [];
      }
    },
    limiter(e) {
      let number = this.pricing_rules.number_apply_discount;
      number = number ? number : 0;
      if (e.length > number) {
        e.pop();
      }
    },
    toggle() {
      if (this.propertyAllSelected) {
        this.pricing_rules.propertys_code = [];
      } else {
        this.pricing_rules.propertys_code = this.listPropertyCode.map(
          property => property.name
        );
      }
    },
    action() {
      if (this.$refs.form.validate()) {
        this.$emit("input", this.pricing_rules);
        this.$emit("action");
      }
    },
    close() {
      this.$emit("close");
    },
    propertiesIdToCode(ids) {
      const map = new Map(
        this.listPropertyCode.map(property => [property.ID, property.name])
      );
      return ids.map(id => map.get(id));
    },
    propertiesCodeToId(codes) {
      const map = new Map(
        this.listPropertyCode.map(property => [property.name, property.ID])
      );
      return codes.map(code => map.get(code));
    }
  }
};
</script>
